<script>
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";

    export default {
        name: "TheContactsEmails",
        components: {
            LinkWithAnalytics,
        },
    };
</script>

<template>
    <div class="the-contacts-emails">
        <ul>
            <li>
                <link-with-analytics
                    type="email"
                    text="miku.kazakhstan@gmail.com"
                ></link-with-analytics>
                <span>Поддержка</span>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    .the-contacts-emails {
        text-align: center;
        @include bp($bp-desktop-sm) {
            text-align: left;
        }
        li {
            &:not(:last-child) {
                margin-bottom: 30px;
                @include bp($bp-desktop-sm) {
                    margin-bottom: 20px;
                }
            }
        }
        a {
            display: block;
            margin-bottom: 10px;
            color: #1c92ff;
            font-size: 20px;
            font-weight: 700;
            line-height: 28px;
            transition: color 0.2s ease-in;
            &:hover {
                color: #fff;
                & ~ span {
                    color: #e9eff5;
                }
            }
            @include bp($bp-desktop-sm) {
                margin-bottom: 8px;
                font-size: 14px;
                font-weight: 600;
                line-height: 18px;
            }
        }
        span {
            color: #acbccc;
            font-size: 12px;
            line-height: 18px;
            transition: color 0.2s ease-in;
        }
    }
</style>
